import { useOutletContext } from 'react-router-dom'

import { GroupsDataCollection } from 'modules/expenses/components/groups/DataCollection'
import { TabRouteContextParams } from 'modules/expenses/lib/RouteContextParams'

const MyGroupsListTab = () => {
  const { employeeIds } = useOutletContext<TabRouteContextParams>()

  return <GroupsDataCollection employeeIds={employeeIds} />
}

export default MyGroupsListTab
